import CTA from 'components/shared/CTA/CTA';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextList from 'components/shared/RichTextList/RichTextList';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { CardsStackedItemBackwardsCompatibleProps } from 'libs/contentful/props';
import { cn, getColorway } from 'utils/styles';
import { RemoteImage } from '@1debit/chimekit';
import Media from '../shared/Media/Media';

const CardsStackedItemCopyVariant = ({
  sys,
  sectionName,
  iconAsset,
  chimeKitIllustrationToken,
  eyebrowRte,
  headline,
  shortDescription,
  cta,
  color,
}: CardsStackedItemBackwardsCompatibleProps) => {
  return (
    <div
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cn(getColorway(color), 'py-8 px-6 sm:p-12 rounded-[20px] flex flex-col gap-6 group')}
      data-testid="cardsGridSimpleItem">
      {iconAsset && (
        <div {...liveUpdateAttrs(sys?.id, 'icon')} data-testid="icon">
          <Media media={iconAsset} className="h-8 object-contain object-center rounded-none" />
        </div>
      )}
      {chimeKitIllustrationToken && !iconAsset && (
        <div {...liveUpdateAttrs(sys?.id, 'chimeKitIconName')} data-testid="chimeKitIllustration">
          <RemoteImage token={chimeKitIllustrationToken} alt="ChimeKit Illustration" />
        </div>
      )}
      {eyebrowRte && (
        <div className="text-eyebrow font-sans" {...liveUpdateAttrs(sys?.id, 'eyebrow')} data-testid="eyebrow">
          <RichTextCopy copy={eyebrowRte} />
        </div>
      )}
      <div
        className="text-heading-md md:text-heading-lg font-sans"
        {...liveUpdateAttrs(sys?.id, 'headline')}
        data-testid="headline">
        <RichTextHeadline headline={headline} />
      </div>
      {shortDescription && (
        <div
          className="flex flex-col gap-6 font-serif text-body-serif "
          {...liveUpdateAttrs(sys?.id, 'shortDescription')}
          data-testid="shortDescription">
          <RichTextList
            item={shortDescription}
            arrowStyles="text-bg-action-primary group-[.bright-green-colorway]:text-kale"
          />
        </div>
      )}
      {cta && (
        <div className="md:max-w-fit mt-2" {...liveUpdateAttrs(sys?.id, 'cta')} data-testid="cta">
          <CTA cta={cta} variant="outline" />
        </div>
      )}
    </div>
  );
};
export default CardsStackedItemCopyVariant;
